/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-07-29 14:32:43
 * @LastEditors: zhaoyuanbang zhaoyuanbang@longfor.com
 * @LastEditTime: 2025-04-30 16:29:02
 * @FilePath: /qd-yunjing-web/src/api/modules/ibms.ts
 * @Description:ibms yemian
 */
import { $request } from '@/utils/request';
import type { AlarmInfoType } from '@/types';
import servers from '../servers';

/**
 * @description: 获取概览列表
 */
export const listProjectPointMonitorInfo = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/ruleMgtType/listProjectPointMonitorInfo`,
  method: 'POST',
  data,
});

/**
 * @description: 获取概览列表
 */
export const getQualityControlEquipments = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getQualityControlEquipments`,
  method: 'post',
  data,
});
/**
 * @description: 获取系统
 */
export const getEquipmentList = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getEquipmentList`,
  method: 'POST',
  data,
});
/**
 * @description: 获取系统
 */
export const getDicts = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getDicts`,
  method: 'get',
  params,
});
/**
 * @description: 获取系统
 */
export const getFireDicts = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getFireDicts`,
  method: 'get',
  params,
});
/**
 * @description: 获取类型
 */
export const getEquipTypes = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getEquipTypes`,
  method: 'get',
  params,
});

/**
 * @description: 指令下发
 */
export const handelControl = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/single/control`,
  method: 'post',
  data,
});
/**
 * @description: 设定值下发
 */
export const setValueImpl = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/single/point_value`,
  method: 'post',
  data,
});

/**
 * @description: 获取设备详细信息
 */
export const getEquipmentPoint = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getEquipmentPoint`,
  method: 'get',
  params,
});

// 历史数据查询 结果查询
export const historySearch = (params = {}) => $request<ResponseData<any[]>>({
  url: `${servers.ibms}/api/history/history-data-value`,
  method: 'get',
  params,
});

// 品质管理-根据属性获取设备
export const getQualityControlDicts = (params = {}) => $request<ResponseData<any[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getQualityControlDicts`,
  method: 'get',
  params,
});
/**
 * @description: 获取消防系统类型
 */
export const getFireAlarmType = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/fireAlarmType`,
  method: 'get',
  params,
});

/**
 * @description: 设定值下发
 */
export const ruleMgtTypeList = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/ruleMgtType/list`,
  method: 'post',
  data,
});

/**
 * @description: 获取设备监控离线详情
 */
export const getOfflineHistoryDetail = (params = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/equipmentManagement/realTime/detail`,
  method: 'get',
  params,
});

/**
 * @description: 设备停用/启用
 */
export const stopAndRecover = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/equipmentMonitor/stopAndRecover`,
  method: 'post',
  data,
});

/**
 * @description: 查询摄像头信息列表
 */
export const getCameraList = (params = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/equipmentMonitor/getCameraList`,
  method: 'get',
  params,
});

/**
 * @description: 设备路由列表
 */
export const getRouterEquipmentList = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/v1/equipment/routing/getEquipmentList`,
  method: 'post',
  data,
});

/**
 * @description: 消防维保监测 - 获取消防分区列表
 */
export const getFireGroupListPageRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.ibms}/api/fireZone/getFireZoneList`,
  method: 'post',
  data,
});
/**
 * @description: 消防维保监测 - 获取消防分区列表-c2
 */
export const getgetFireZoneListPageRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/spaceInfo/getFireZoneList`,
  method: 'post',
  data,
});

/**
 * @description: 根据code查询实时报警
 */
export const getRealTimeAlarmByEquipCodes = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/getRealTimeAlarmByEquipCodes`,
  method: 'post',
  data,
});
